// ===== Geo currency auto-switch for Australia =====
(function () {
  const TARGET_COUNTRY = "AU";
  const USER_CURRENCY = "AUD";
  const SESSION_KEY = "currencySet";
  const LOCALIZATION_INPUT_SELECTOR =
    "localization-form input[name='country_code']";
  const COUNTRY_OPTION_SELECTOR = (country) =>
    `ul.countries a[data-value="${country}"]`;

  function applyCurrency() {
    const input = document.querySelector(LOCALIZATION_INPUT_SELECTOR);
    if (!input) return;

    if (
      sessionStorage.getItem(SESSION_KEY) === "isSet" &&
      input.value === TARGET_COUNTRY
    ) {
      return;
    }

    if (input.value === TARGET_COUNTRY) {
      sessionStorage.setItem(SESSION_KEY, "isSet");
      sessionStorage.setItem("userCurrency", USER_CURRENCY);
      return;
    }

    input.click();

    setTimeout(() => {
      const link = document.querySelector(
        COUNTRY_OPTION_SELECTOR(TARGET_COUNTRY),
      );
      if (!link) return;

      link.click();

      sessionStorage.setItem(SESSION_KEY, "isSet");
      sessionStorage.setItem("userCurrency", USER_CURRENCY);
    }, 300);
  }

  function run() {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", applyCurrency, {
        once: true,
      });
    } else {
      applyCurrency();
    }
  }

  GeoCountryCache.getCountry(function (country) {
    if (country === TARGET_COUNTRY) {
      run();
    }
  });
})();
